import z from "zod";

const zPlanningRowCommon = z.object({
  name: z.string(),
  duration: z.number().nullish(),
  plannedStartDate: z.string().nullish(),
  plannedEndDate: z.string().nullish(),
  actualStartDate: z.string().nullish(),
  actualEndDate: z.string().nullish(),
});

const zPlanning2Task = z.object({
  kind: z.literal("task"),
  id: z.string(),
  ...zPlanningRowCommon.shape,
  previousTaskId: z.string().nullish(),
  taskGroupId: z.string().nullish(),
  taskGroupLabel: z.string().nullish(),
  employeeId: z.string().nullish(),
  employeeLabel: z.string().nullish(),
  departmentId: z.string().nullish(),
  departmentLabel: z.string().nullish(),
  priorityId: z.string().nullish(),
  priorityLabel: z.string().nullish(),
  stateId: z.string().nullish(),
  stateName: z.string().nullish(),
  forecastStartDate: z.string().nullish(),
  forecastEndDate: z.string().nullish(),
  delay: z.number().nullish(),
});

export type ZPlanning2Task = z.infer<typeof zPlanning2Task>;

const zPlanning2Group = z.object({
  kind: z.literal("group"),
  id: z.string(),
  children: zPlanning2Task.array(),
  ...zPlanningRowCommon.shape,
});

export const zPlanning2Row = z.discriminatedUnion("kind", [
  zPlanning2Group,
  zPlanning2Task,
]);
export type ZPlanning2Row = z.infer<typeof zPlanning2Row>;

export const zPlanning2Table = z.object({
  startDate: z.string().nullish(),
  endDate: z.string().nullish(),
  tasks: zPlanning2Row.array(),
});
export type ZPlanning2Table = z.infer<typeof zPlanning2Table>;

export const isPl2RowComplete = (row: ZPlanning2Row): boolean => {
  // 9.1 Триггеры завершения задачи:Заполнен Факт.окончания
  if (row.kind === "task") {
    return !!row.actualEndDate;
  }
  return false;
};
